import { createFileRoute, redirect } from '@tanstack/react-router'
import Loader from '@/components/common/Loader'
import { lazy, Suspense } from 'react'

const AllPermitsPage = lazy(async () => {
  const module = await import(
    '@/features/city-clerk/all-permits/pages/AllPermitsPage/AllPermitsPage'
  )
  return { default: module.default }
})

export const Route = createFileRoute('/(app)/city-clerk/$id/overall-permits')({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.overallPermitsView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Suspense
      fallback={
        <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
          <Loader size="lg" />
        </div>
      }
    >
      <AllPermitsPage />
    </Suspense>
  )
}
